/*       */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Typography } from '@mic3/platform-ui';
import styled from 'styled-components';

import { showToastr } from 'store/actions/app/appActions';
import { bind, memoize } from 'app/utils/decorators/decoratorUtils';
import { get } from 'app/utils/lo/lo';
import LocationMap from 'app/components/molecules/Map/LocationMap/LocationMap';
import GraphQLLocationTypeahead from 'app/components/organisms/Form/Typeahead/GraphQLLocationTypeahead';

const Wrapper = styled.div`
    margin: 10px 0;
`;

const TypographyStyled = styled(Typography)`
    padding: 8px 0;
`;

class GeotagAddress extends PureComponent {
    state = {
        mapKey: 1,
    };

    componentDidUpdate(prevProps) {
        const { value } = this.props;
        if (prevProps.value !== value) {
            this.reload();
        }
    }

    @bind
    reload() {
        this.setState((state) => ({ mapKey: state.mapKey + 1 }));
    }

    @bind
    handleLocationChange(event) {
        const { value } = event.target;
        let compiledValue = null;
        if (value) {
            const { address, location, display_name } = value;
            const { lat, lng } = location || {};
            compiledValue = { address, latitude: Number(lat), longitude: Number(lng), display_name };
        }
        this.props.onChange({ target: { value: compiledValue, name: this.props.name } });
    }

    @bind
    handleMarkerPostionChange({ lat, lng }) {
        const { value, name } = this.props;
        const compiledValue = { ...(value || {}), latitude: lat, longitude: lng };
        this.props.onChange({ target: { value: compiledValue, name } });
    }

    @bind
    @memoize()
    buildMarker(value) {
        if (!value) {
            return null;
        }
        return { lat: value.latitude, lng: value.longitude };
    }

    render() {
        const { value, label, withMap, withCoords, placeholder, disabled, allowPinDrag } = this.props;
        const marker = this.buildMarker(value);
        const typeaheadProps = {
            value,
            onChange: this.handleLocationChange,
            disabled,
            label,
            placeholder,
        };
        return (
            <Wrapper>
                <GraphQLLocationTypeahead {...typeaheadProps} />
                {withCoords && marker && (
                    <TypographyStyled>
                        Latitude: {get(marker, 'lat')} Longitude: {get(marker, 'lng')}
                    </TypographyStyled>
                )}
                {withMap && marker && (
                    <div style={{ height: '300px', width: '100%' }}>
                        <LocationMap
                            mapId='geo_tag_address_map'
                            markers={[marker]}
                            onChange={this.handleMarkerPostionChange}
                            allowPinDrag={!disabled && allowPinDrag}
                        />
                    </div>
                )}
            </Wrapper>
        );
    }
}

export default connect(null, { showToastr })(GeotagAddress);
